<template><svg viewBox="-50 -50 100 100" stroke-width="15">
    <defs>
        <linearGradient id="gradient" x1="0%" y1="30%" x2="0%" y2="100%" x3="0%" y3="50%">
            <stop offset="0%" stop-color="#0096C8" />
            <stop offset="50%" stop-color="#005E55" />
            <stop offset="100%" stop-color="#BA431C" />
        </linearGradient>
    </defs>
    <circle :r="45"></circle>
    <circle :r="45" :stroke-dasharray="282.7433388230814" :stroke-dashoffset="226.19467105846513" stroke="url(#gradient)"></circle>
</svg></template>